import React, {createContext, useState, useEffect, useContext} from 'react';
import dayjs from 'dayjs';
import { useTimezone } from "./TimezoneContext"; // Import your existing context

interface DateContextType {
  selectedDate: dayjs.Dayjs;
  setSelectedDate: (date: dayjs.Dayjs) => void;
}

const DateContext = createContext<DateContextType | undefined>(undefined);

const DateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { selectedTimezone } = useTimezone();

  // Initialize with the current timezone
  const [selectedDate, setSelectedDate] = useState(dayjs().tz(selectedTimezone));

  // Update the date's internal timezone whenever the global timezone changes
  useEffect(() => {
    setSelectedDate((currentDate) => {
      // This forces the dayjs object to recalculate its wall-clock time
      // based on the new timezone string.
      return currentDate.tz(selectedTimezone);
    });
  }, [selectedTimezone]);

  return (
      <DateContext.Provider value={{ selectedDate, setSelectedDate }}>
        {children}
      </DateContext.Provider>
  );
};

export const useDate = () => {
  const context = useContext(DateContext);
  if (context === undefined) {
    throw new Error('useDate must be used within a DateProvider');
  }
  return context;
};

export { DateContext, DateProvider };
